import { selfInstantiateOnLoad } from "../utils";
import MoreInfoModal from "./moreInfoModal";
import PriceStakDisclaimerModal from "./priceStakDisclaimerModal";
var DropdownEvent;
(function (DropdownEvent) {
    DropdownEvent["SHOW"] = "show";
    DropdownEvent["HIDE"] = "hide";
})(DropdownEvent || (DropdownEvent = {}));
var DropdownButtonText;
(function (DropdownButtonText) {
    DropdownButtonText["MORE"] = "More";
    DropdownButtonText["LESS"] = "Less";
})(DropdownButtonText || (DropdownButtonText = {}));
var DoTaggingResult;
(function (DoTaggingResult) {
    DoTaggingResult["INCREASE"] = "increase";
    DoTaggingResult["DECREASE"] = "decrease";
})(DoTaggingResult || (DoTaggingResult = {}));
const elementSelectorName = "data-pricestak-element";
const dropdownSelector = `[${elementSelectorName}="collapse"]`;
const dropdownButtonSelector = `[${elementSelectorName}="collapse-button"]`;
const dropdownButtonLabelSelector = `[${elementSelectorName}="collapse-button-label"]`;
export default class PriceStak {
    constructor() {
        this.$ = globalThis.jQuery;
        this.getElements = () => {
            this._dropdowns = document.querySelectorAll(dropdownSelector);
            this._dropdownButtons = document.querySelectorAll(dropdownButtonSelector);
            this._dropdownButtonLabels = document.querySelectorAll(dropdownButtonLabelSelector);
        };
        this.toggleAllDropdowns = (eventType) => {
            const newButtonLabel = eventType === DropdownEvent.SHOW
                ? DropdownButtonText.LESS
                : DropdownButtonText.MORE;
            const newButtonDoTaggingResult = eventType === DropdownEvent.SHOW
                ? DoTaggingResult.DECREASE
                : DoTaggingResult.INCREASE;
            for (let i = 0; i < this._dropdownButtons.length; i++) {
                const label = this._dropdownButtonLabels[i];
                const dropdown = this._dropdowns[i];
                const doTaggedButton = this._dropdownButtons[i];
                doTaggedButton.setAttribute("data-dotagging-event-action-result", newButtonDoTaggingResult);
                label.innerText = newButtonLabel;
                this.$(dropdown).collapse(eventType);
            }
        };
        this.addDropdownListeners = () => {
            if (this._dropdowns && this._dropdownButtonLabels) {
                for (let i = 0; i < this._dropdownButtons.length; i++) {
                    const button = this._dropdownButtons[i];
                    button.addEventListener("click", (event) => {
                        this.dropdownButtonCallback(event);
                    });
                }
                this.$(this._dropdowns).on("hidden.bs.collapse", () => {
                    this.toggleDropdownResizeObservation(false);
                });
                this.$(this._dropdowns).on("shown.bs.collapse", () => {
                    this.toggleDropdownResizeObservation(false);
                });
            }
        };
        this.dropdownButtonCallback = (event) => {
            event.preventDefault();
            const clickedElement = event.currentTarget;
            const clickedButton = clickedElement.closest(dropdownButtonSelector);
            const target_DropdownSelector = clickedButton?.dataset?.target;
            this._currentDropdown = document.querySelector(target_DropdownSelector);
            const scrollbarPositionBeforeToggle = document.documentElement.scrollTop;
            const scrollHeightBeforeToggle = document.documentElement.scrollHeight;
            this._currentScrollbarRatio =
                scrollbarPositionBeforeToggle / scrollHeightBeforeToggle;
            const ariaExpanded = clickedButton.getAttribute("aria-expanded");
            this.toggleDropdownResizeObservation(true);
            if (ariaExpanded != null) {
                const eventType = ariaExpanded === "true" ? DropdownEvent.HIDE : DropdownEvent.SHOW;
                this.toggleAllDropdowns(eventType);
            }
        };
        this.addDropdownResizeObserver = () => {
            this._resizeObserver = new ResizeObserver(() => {
                const scrollHeightAfterToggle = document.documentElement.scrollHeight;
                const scrollbarPositionAfterToggle = scrollHeightAfterToggle * this._currentScrollbarRatio;
                document.documentElement.scrollTo({ top: scrollbarPositionAfterToggle });
            });
        };
        this.toggleDropdownResizeObservation = (shouldObserve) => {
            if (this._currentDropdown) {
                if (shouldObserve) {
                    this._resizeObserver.observe(this._currentDropdown);
                }
                else {
                    this._resizeObserver.unobserve(this._currentDropdown);
                }
            }
        };
        this.initRebateIconMaskStyling = () => {
            const head = document.getElementsByTagName("head")[0];
            const styleTag = document.createElement("style");
            const rebateImageIcons = document.querySelectorAll(".priceBlockItemPriceButton .priceBlockItemPriceButtonIcon img");
            // Get the mask image for the icon from INV controlled html, or use the default if they don't have one
            const rebateImageUrl = rebateImageIcons.length > 0
                ? rebateImageIcons.item(0).src
                : "https://cdn.dlron.us/static/industry-automotive/icons/icon_info.svg";
            styleTag.innerHTML = `
      :root {
        --rebate-icon-url: url('${rebateImageUrl}');
      }
    `;
            head.appendChild(styleTag);
        };
        this.getElements();
        this.addDropdownListeners();
        this.addDropdownResizeObserver();
        this.initRebateIconMaskStyling();
        if (document.querySelector("[data-scan-mode='true']")) {
            this.toggleAllDropdowns(DropdownEvent.SHOW);
        }
        new PriceStakDisclaimerModal(new MoreInfoModal()).register();
    }
}
selfInstantiateOnLoad(PriceStak);
